import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Filter")
const _hoisted_2 = { class: "w-full h-full flex flex-col items-center max-h-screen px-4 pt-4" }
const _hoisted_3 = { class: "w-full h-auto flex flex-col my-3" }

import { ref } from 'vue';
import { 
  IonContent, 
  IonHeader, 
  IonPage, 
  IonToolbar, 
  IonButtons, 
  IonTitle,
  IonBackButton,
  modalController,
} from '@ionic/vue';
import { useCompany } from '@/store/company';
import ActiveFilterChipLayout from './ActiveFilterChipLayout.vue';
import FilterList from './FilterList.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterModal',
  setup(__props) {

const companyStore = useCompany()
const filterChanged = ref(false)

async function dismiss() {
  await modalController.dismiss(filterChanged.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonBackButton), {
                    text: "",
                    style: {"--color":"#444444"},
                    "default-Href": "/",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (dismiss()))
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(ActiveFilterChipLayout, {
              onFilterChanged: _cache[1] || (_cache[1] = ($event: any) => (filterChanged.value = true)),
              class: "pb-4"
            }),
            _createVNode(FilterList, {
              "list-class": "h-0 flex-grow w-full overflow-y-auto pt-0",
              onFilterChanged: _cache[2] || (_cache[2] = ($event: any) => (filterChanged.value = true))
            }),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (dismiss())),
                style: _normalizeStyle('background-color: ' + _unref(companyStore).activeCompany.color),
                class: "w-full h-10 text-white font-bold rounded-lg translate cursor-pointer flex justify-center items-center active:scale-95 duration-200"
              }, " Zurück ", 4)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})